<script lang="ts">
  import Check from 'phosphor-svelte/lib/Check';

  import { useSelectContext } from '../use-select-context';
  import { selectStyles } from '../select.styles.js';
  import { checkboxStyles } from '../../checkbox/checkbox.styles';
  import { css } from '@agapi/ui/panda/css';
  import type { SelectItemComponentProps } from '../select.types';

  const { item, css: cssProp, ...itemProps }: SelectItemComponentProps = $props();
  const select = useSelectContext();

  const { item: itemStyles } = selectStyles.raw();
  const checkboxClasses = checkboxStyles();
</script>

<li {...select.api.getItemProps({ item, ...itemProps })} class={css(itemStyles, cssProp)}>
  <span {...select.api.getItemTextProps({ item })} class={checkboxClasses.label}>
    {item.label}
  </span>
  <span class={checkboxClasses.count}>{item.count}</span>

  {#if select.api.getHiddenSelectProps().multiple}
    <div class={checkboxClasses.control}>
      <Check class={checkboxClasses.indicator} weight="bold" width={13} />
    </div>
  {/if}
</li>
